const base = {
  url: `${process.env.VUE_APP_BASE_URL}/api`,
  index: process.env.VUE_APP_BASE_URL,
  auth_url: `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${process.env.VUE_APP_LOGIN_CALLBACK}&app_id=${process.env.VUE_APP_APP_ID}`,
};

export default base;
